import React from "react";
import '../styles/services.scss';
import { MdOutlineRocketLaunch,  } from "react-icons/md";
import { TbDeviceAnalytics, TbDeviceDesktopCode } from "react-icons/tb";
import { AiOutlineCloudServer } from "react-icons/ai";
import { FaCode,  FaReact, FaPython, FaJs, FaTypo3, FaFlask , } from "react-icons/fa";


export default function DiscoverySession() {

    // Nav Link Scroll To Section
    let navLinkScrollToSection = (section: any) => {
        let element = document.getElementById(section);
        element?.scrollIntoView({ behavior: "smooth" });
    };


    return (
        <section id="services" className="overflow-hidden">
            <div className="container">
                <div className="d-flex flex-column gap-2 mb-lg-5 mb-md-4 mb-5">
                    <h1 className="h2 fw-bold text-center text-uppercase text-gradient m-0">Delivering Real-World Solutions</h1>
                    <p className="text-center m-0">Build scalable web applications and create seamless user experiences. Turning your Web and App dreams into reality</p>
                </div>
                <div className="row m-0 gap-5 gap-md-0">
                    <div className="col-md-6 p-0 px-lg-5 px-md-4 ps-lg-0 ps-md-0 column-1" data-aos="fade-right">
                        <div className="d-flex flex-column gap-md-3 gap-2 w-100">
                            <div className="m-0 text-center text-md-start">
                                <span className="icon h1 p-4 rounded-circle m-0 d-inline-flex justify-content-center align-items-center"><MdOutlineRocketLaunch /></span>
                            </div>
                            <h2 className="h3 m-0 heading-color text-center text-md-start">Experience </h2>
                            <p className="m-0 text-center text-md-start">Frontend Developer (Remote) | CONCEPTZI</p>
                            <p className="m-0 text-center text-md-start"> <i>March 2023 – Present</i></p>
                            <div className="m-0 text-center text-md-start">
                                <ul><li>Implemented responsive and accessible user interfaces using Next.js, React, and CSS.</li>
                                <li>Utilized Redux for state management and React Router for enhanced navigation.</li>
                                <li>Contributed to a scalable e-commerce platform, optimizing performance and user engagement.</li>
                                <li>Integrated external APIs and services to expand platform capabilities.</li></ul>
</div>
                            <div className="d-flex flex-wrap justify-content-center justify-content-md-start gap-2">
                                <small className="service px-3 py-2 rounded-pill d-flex align-items-center gap-2">
                                    <TbDeviceAnalytics className="service_icon" />
                                    <span>Web Designer</span>
                                </small>
                                <small className="service px-3 py-2 rounded-pill d-flex align-items-center gap-2">
                                    <AiOutlineCloudServer className="service_icon" />
                                    <span>Frontend Development</span>
                                </small>
                                <small className="service px-3 py-2 rounded-pill d-flex align-items-center gap-2">
                                    <TbDeviceDesktopCode className="service_icon" />
                                    <span>Web App Development</span>
                                </small>
                              
                            </div>
                         
                        </div>
                    </div>
                    <div className="col-md-6 p-0 px-lg-5 px-md-4 pe-lg-0 pe-md-0 column-2" data-aos="fade-left">
                        <div className="d-flex flex-column gap-md-3 gap-2 w-100">
                            <div className="m-0 text-center text-md-start">
                                <span className="icon h1 p-4 rounded-circle m-0 d-inline-flex justify-content-center align-items-center"><FaCode /></span>
                            </div>
                            <h2 className="h3 m-0 heading-color text-center text-md-start">Skill</h2>
                            <p className="m-0 text-center text-md-start">A well-rounded skill set honed through hands-on experience, continuous learning, and a passion for technology</p>
                            <div className="d-flex flex-wrap justify-content-center justify-content-md-start gap-2">
                                <small className="service px-3 py-2 rounded-pill d-flex align-items-center gap-2">
                                    <FaPython className="service_icon" />
                                    <span>Python</span>
                                </small>
                                <small className="service px-3 py-2 rounded-pill d-flex align-items-center gap-2">
                                    <FaJs className="service_icon" />
                                    <span>Javascript</span>
                                </small>
                                <small className="service px-3 py-2 rounded-pill d-flex align-items-center gap-2">
                                    <FaTypo3 className="service_icon" />
                                    <span>Typescript</span>
                                </small>
                                <small className="service px-3 py-2 rounded-pill d-flex align-items-center gap-2">
                                    <FaCode className="service_icon" />
                                    <span>Next.js</span>
                                </small>
                                <small className="service px-3 py-2 rounded-pill d-flex align-items-center gap-2">
                                    <FaReact className="service_icon" />
                                    <span>React</span>
                                </small>
                                <small className="service px-3 py-2 rounded-pill d-flex align-items-center gap-2">
                                    <FaFlask className="service_icon" />
                                    <span>Flask</span>
                                </small>

                                <small className="service px-3 py-2 rounded-pill d-flex align-items-center gap-2">
                                    <FaCode className="service_icon" />
                                    <span>Django</span>
                                </small>
                            </div>
                            <div className="m-0 text-md-start text-center">
                                <span onClick={() =>navLinkScrollToSection("audit")} className="btn btn-primary btn-theme rounded-3">Hire</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}